export class BackendUriUnits {
    public static API = 'api';
    public static ACTIVITY_LOG = 'activitylog';
    public static ADDRESS_BOOK = 'addressbook';
    public static ATTACHMENTS = 'attachments';
    public static BANNER = 'banner';
    public static CASE = 'case';
    public static CASE_NO = 'caseno';
    public static CASES = 'cases';
    public static CLAIM_TYPES = 'claim_types';
    public static CLIENTS = 'clients';
    public static CLIENT = 'client';
    public static COMMENTS = 'comments';
    public static CONTACTS = 'contacts';
    public static CONTENT_STORE = 'contentstore';
    public static CREDENTIALS = 'credentials';
    public static DATA = 'data';
    public static DECISIONS = 'decisions';
    public static DEPARTMENTS = 'departments';
    public static DISTRIBUTION = 'distribution';
    public static DISTRIBUTION_OPTION = 'distribution_option';
    public static DISPATCHER = 'dispatcher';
    public static FILES = 'files';
    public static JOBS = 'jobs';
    public static JOURNAL = 'journal';
    public static LOGIN = 'login';
    public static MFA_LOGIN = 'mfa_login';
    public static MULTI_LOGIN = 'multi_login';
    public static VERIFY_LOGIN = 'verify';
    public static MEMBER = 'member';
    public static MFA = 'mfa';
    public static OFFICES = 'offices';
    public static PARTICIPANTS = 'participants';
    public static POTENTIAL_PARTICIPANTS = 'potentialparticipants';
    public static PREFERENCES = 'preferences';
    public static PROVIDERS = 'providers';
    public static RESULT = 'result';
    public static SESSION = 'session';
    public static SETTINGS = 'settings';
    public static SMP = 'smp';
    public static SUPPORT_ACCESS = 'support_access';
    public static TEMPLATES = 'templates';
    public static TYPES = 'types';
    public static USER = 'user';
    public static USERS = 'users';
    public static VEHICLE_CODES = 'vehicle_selection';
    public static WORK_INSTRUCTIONS = 'instructions';
    public static PAYMENTS = 'payments';
    public static PAYMENT_TYPES = 'payment_types';
    public static PAYMENT_RECEIVERS = 'payment_receiver';
    public static MESSAGES = 'messages';
    public static DASHBOARD = 'dashboard';
    public static BILLING = 'billing';
    public static EVENTS = 'events';
    public static WORKFLOW = 'workflow';
    public static WORKFLOWS = 'workflows';
}
